// Defines all of the sections used to group fields.
// See README.md for more info

import generalFields from './generalFields'
import clientFields from './clientFields'
import housingFields from './housingFields'
import shelterFields from './shelterFields'
import incomeFields from './incomeFields'
import expensesFields from './expensesFields'
import serviceFields from './serviceFields'
import incomeProofFields from './incomeProofFields'
import proofOfServicesFields from './proofOfServicesFields'
import authorizationFields from './authorizationFields'

export default [

  {
    id: 'general',
    label: 'General Information',
    fields: generalFields
  },
  {
    id: 'client',
    label: 'Personal Information',
    fields: clientFields
  },
  {
    id: 'housing',
    label: 'Housing Information',
    fields: housingFields
  },  
  {
    id: 'income',
    label: 'Monthly Income',
    fields: incomeFields
  },
  {
    id: 'expense',
    label: 'Monthly Expenses',
    fields: expensesFields
  },
  {
    id: 'service',
    label: 'Services Needed',
    fields: serviceFields
  },
  {
    id: 'incomeProof',
    label: 'Proof of Income',
    fields: incomeProofFields
  },
  {
    id: 'servicesProof',
    label: 'Proof of Services',
    fields: proofOfServicesFields
  },
  {
    id: 'authorization',
    label: 'Authorization',
    fields: authorizationFields
  },
  {
    id: 'review',
    label: 'Review',
    fields: []
  }
]

